import { formatUnitPrice } from "services/api/pricing/consts";
import { PricingCombination, PricingPack } from "services/api/pricing/types";
import { Badge } from "ui/components/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

/**
 * Stupci primaju packove jer se šifra packa pretvara u njegov naziv.
 *
 * Kombinacija je skup redaka, ne stupac — zato se matrica širi dodavanjem packa kroz sučelje,
 * bez izmjene koda.
 */
export const VEHICLE_PRICE_COLUMNS = (packs: PricingPack[]): Column[] => {
  const packName = (code: string): string =>
    packs.find((pack) => pack.code === code)?.name ?? code;

  return [
    {
      title: "Kombinacija",
      field: "keyCode",
      sortable: true,
      type: ColumnTypes.custom,
      render: (row: PricingCombination) => (
        <div>
          <div className="flex flex-wrap items-center gap-1.5">
            {row.packCodes.map((code) => (
              <Badge
                key={code}
                text={packName(code)}
                variant={code === "core" ? "secondary" : "info"}
                height="small"
              />
            ))}
          </div>

          {row.description && (
            <p className="text-sm text-slate-500 mt-1">{row.description}</p>
          )}

          <p className="text-xs text-slate-400 mt-1 font-mono">{row.keyCode}</p>
        </div>
      ),
    },
    {
      title: "€ / vozilo / mj",
      field: "price",
      sortable: true,
      type: ColumnTypes.custom,
      render: (row: PricingCombination) => (
        <span className="font-semibold text-slate-700 whitespace-nowrap">
          {formatUnitPrice.format(row.price)}
        </span>
      ),
    },
  ];
};
